import { useEffect, useState } from 'react';

import { MOBILE_MEDIA_QUERY } from './constants';
import type { UseMobileViewportReturn } from './types';

// SSR-safe: `window` is unavailable during hydration in some harnesses.
const getInitialMatch = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

const useMobileViewport = (): UseMobileViewportReturn => {
    const [isMobile, setIsMobile] = useState<boolean>(getInitialMatch);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);

        const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

        setIsMobile(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', handleChange);

        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, []);

    return { isMobile };
};

export default useMobileViewport;
